import React from 'react';
import { withRouter } from 'react-router';

const allowedPath = [
  '/', '/case', '/about', '/company', '/contact', '/contact/success'
];
const windowPath = window.location.pathname;

/**
 * 경로에 따라서 다르게 보여주는 이유는 Jumbotron이 페이지 이동 할 때마다 
 * re-rendering되는 것을 막기 위해서이다. 
 * 처음 Client가 페이지 접근 시에는 window path로 판단하고 그 이후에는
 * router path로 경로를 판단한다.
 */

export function withRender<P extends object, C>(
  WrappedComponent: React.ComponentType<P> & C,
) {
  interface Props {
    location: any,
  }

  class WithRender extends React.Component<Props, {}> {

    render() {
      const routerPath = this.props.location.pathname;
      const currentPath = routerPath ? routerPath : windowPath;
      
      return allowedPath.includes(currentPath) ? <WrappedComponent {...this.props as any} /> : null;
    }
  }

  return withRouter(props => <WithRender {...props} />);
}; 
